import React, { useState } from "react";

interface FormDropdownProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: { value: string; label: string }[];
  required?: boolean;
}

const FormDropdown: React.FC<FormDropdownProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  options,
  required = false,
}) => {
  const [isOpen, setIsOpen] = useState(false); // For dropdown icon animation

  return (
    <div className="relative">
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-100 mb-1"
      >
        {label}
      </label>
      <select
        id={id}
        name={name}
        value={value}
        onChange={(e) => {
          onChange(e);
          setIsOpen(false); // Close dropdown
        }}
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        required={required}
        className="w-full px-4 py-2 pr-10 rounded-lg bg-zinc-300 text-black border border-zinc-100 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none"
      >
        <option value="">Select an Option</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {/* Dropdown Icon */}
      <div className="absolute top-8 right-0 flex items-center pr-3 pointer-events-none">
        <svg
          className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </div>
  );
};

export default FormDropdown;
